import isValidDate from "../isValidDate";

const keepValidDateOrReturnUndefined = (date: Date): Date | undefined =>
  isValidDate(date) ? date : undefined;

export default keepValidDateOrReturnUndefined;
